<template>
  <div class="space-bottom">
    <b-row class="align-items-center justify-content-between">
      <b-col md="6" cols="12">
        <div class="d-flex mt-2">
          <p class="mt-2 mr-3 f-18px">เลขที่เอกสาร</p>
          <InputText
            type="text"
            className=" bg-second flex-grow-1"
            placeholder="เลขที่"
            textField=""
            :value="form.inventory_check_no"
            disabled
          />
        </div>
      </b-col>

      <b-col md="4" cols="12">
        <div class="mt-2">
          <p class="mt-2 mr-2 title text-right">
            ผู้สร้าง : {{ form.sales_name }} <br />

            <span
              :class="{
                'text-warning': form.status == 2,
                'text-danger': form.status == 5,
                'text-success': form.status == 3 || form.status == 4,
                'text-info':
                  form.status == 7 || form.status == 1 || form.status == 0,
              }"
            >
              สถานะ :
              {{ form.status_name || "รับเข้าสาขา" }}
            </span>

            <span v-if="form.status == 4">
              ผู้สร้าง : {{ form.approved_name }}
            </span>
          </p>
          <p class="mt-2 mr-2 title text-right" v-if="form.billNo">
            หมายเลขใบเสร็จ :
            <span
              class="text-link"
              @click="
                $router.push(
                  `/transaction/detail/${form.repair_user_transaction_id}/${form.repair_owner_user_guid}/0`
                )
              "
              >{{ form.billNo }}</span
            >
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="9">
        <div class="d-flex align-items-center f-14">
          <p class="text-gray title-w">วันที่สต๊อก</p>
          <p class="text-gray">:</p>
          <div class="display-user-value ml-2">
            {{
              form.set_stock_time
                ? $moment(form.set_stock_time).format("DD/MMM/YYYY (HH:mm)")
                : ""
            }}
          </div>
          <b-button
            class="ml-2"
            variant="outline-primary-color"
            @click="handleCountDown()"
            v-if="!form.set_stock_by"
          >
            <font-awesome-icon
              icon="clock"
              style="color: var(--primary-color)"
            ></font-awesome-icon>
            ตั้งสต๊อก
          </b-button>
        </div>
      </b-col>

      <b-col md="3" cols="12" class="text-right">
        <b-dropdown
          no-caret
          ref="dropdown"
          class="mr-2"
          variant="outline-primary-color"
          right
        >
          <template #button-content> รายงาน </template>

          <b-dropdown-item @click="page = 2">
            รายการสรุปตามชนิด
          </b-dropdown-item>
          <b-dropdown-item @click="page = 3">
            รายการสรุปรายชิ้น
          </b-dropdown-item>
        </b-dropdown>
        <b-button
          variant="outline-primary-color"
          @click="isShowScanProduct"
          v-if="[1, 2].includes(form.status)"
        >
          <font-awesome-icon
            icon="barcode"
            style="color: var(--primary-color)"
          ></font-awesome-icon>
          สแกน
        </b-button>
        <b-button
          variant="outline-primary-color"
          @click="exportItems"
          v-if="[2, 3].includes(page)"
          class="ml-2"
        >
          <font-awesome-icon
            icon="barcode"
            style="color: var(--primary-color)"
          ></font-awesome-icon>
          Export
        </b-button>
      </b-col>
    </b-row>

    <template v-if="page == 1">
      <b-tabs v-model="tabIndex" class="mt-3">
        <b-tab :title="'รายการที่ยังไม่ได้สแกน'">
          <template #title>
            รายการที่ยังไม่ได้สแกน
            <b-badge pill>{{ productCount[0].count }}</b-badge>
          </template>
          <InputText
            v-model="filter.search"
            type="text"
            faIcon="search"
            className="my-3 bg-second w-50"
            placeholder="ค้นหาสินค้า"
            @onClickIcon="getProductList(tabIndex)"
            textField="telephone"
            @onEnter="getProductList(tabIndex)"
          />
          <b-table
            striped
            hover
            :busy="isBusy"
            :items="notScanItems"
            :fields="fields"
            show-empty
            empty-text="No matching records found"
          >
            <template v-slot:cell(barcode)="data">
              {{ data.item.barcode }}{{ data.item.serial_name }}
            </template>
            <template v-slot:cell(document_no)="data">
              {{ data.item.document_no || "-" }}
            </template>
            <template v-slot:cell(serial_name)="data">
              {{ data.item.serial_name || "-" }}
            </template>
            <template v-slot:cell(image_url)="{ item }">
              <img
                :src="item.image_url"
                class="img-size"
                v-if="item.image_url"
              />
              <img
                v-else
                src="@/assets/images/noimg.png"
                alt="no-image-product"
                class="img-size"
              />
            </template>
            <template v-slot:cell(created_time)="data">
              <div class="text-center text-black my-2">
                {{ $moment(data.item.created_time).format("DD/MM/YYYY") }}
                <br />
                {{ $moment(data.item.created_time).format("HH:mm") }}
              </div>
            </template>
            <template v-slot:cell(product_price)="data">
              {{ data.item.product_price | numeral("0,0") }}
            </template>
            <template v-slot:cell(action)="data">
              <div class="d-flex align-items-center justify-content-center">
                <font-awesome-icon
                  @click="toggleDetail(data)"
                  icon="clipboard"
                  title="detail"
                  class="mr-2 pointer"
                />
                <font-awesome-icon
                  icon="pencil-alt"
                  title="detail"
                  class="ml-2 pointer"
                  @click="goDetail(data.item.id)"
                />
              </div>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
          <Pagination
            @handleChangeTake="handleChangeTake"
            :pageOptions="pageOptions"
            :filter="filter"
            :rows="rows"
            @pagination="pagination"
          />
        </b-tab>
        <b-tab title="รายการที่สแกนแล้ว" :disabled="id == 0">
          <template #title>
            รายการที่สแกนแล้ว
            <b-badge pill>{{ productCount[1].count }}</b-badge>
          </template>
          <InputText
            v-model="filter.search"
            type="text"
            faIcon="search"
            className="my-3 bg-second w-50"
            placeholder="ค้นหาสินค้า"
            @onClickIcon="onSearch"
            textField="telephone"
            @onEnter="onSearch"
          />
          <b-table
            striped
            hover
            :busy="isBusy"
            :items="scanItems"
            :fields="fields"
            show-empty
            empty-text="No matching records found"
          >
            <template v-slot:cell(barcode)="data">
              {{ data.item.barcode }}{{ data.item.serial_name }}
            </template>
            <template v-slot:cell(document_no)="data">
              {{ data.item.document_no || "-" }}
            </template>
            <template v-slot:cell(serial_name)="data">
              {{ data.item.serial_name || "-" }}
            </template>
            <template v-slot:cell(product_price)="data">
              {{ data.item.product_price | numeral("0,0") }}
            </template>
            <template v-slot:cell(image_url)="{ item }">
              <img
                :src="item.image_url"
                class="img-size"
                v-if="item.image_url"
              />
              <img
                v-else
                src="@/assets/images/noimg.png"
                alt="no-image-product"
                class="img-size"
              />
            </template>
            <template v-slot:cell(created_time)="data">
              <div class="text-center text-black my-2">
                {{ $moment(data.item.created_time).format("DD/MM/YYYY") }}
                <br />
                {{ $moment(data.item.created_time).format("HH:mm") }}
              </div>
            </template>
            <template v-slot:cell(count_stock)="data">
              <InputText
                type="number"
                v-model="data.item.count_stock"
                v-if="form.status == 2"
                @onKeypress="(event) => updateCountstock(event, data.item)"
              />
              <div v-else>{{ data.item.count_stock }}</div>
            </template>

            <template v-slot:cell(action)="data">
              <div class="d-flex align-items-center justify-content-center">
                <font-awesome-icon
                  v-if="data.item.status < 3"
                  @click="removeProduct(data.item.id)"
                  icon="trash-alt"
                  title="detail"
                  class="mr-2 pointer"
                />
              </div>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
          <Pagination
            @handleChangeTake="handleChangeTake"
            :pageOptions="pageOptions"
            :filter="filter"
            :rows="rows"
            @pagination="pagination"
          />
        </b-tab>
      </b-tabs>

      <ModalScanProduct
        ref="ModalScanProduct"
        @fetch="refreshProduct(tabIndex)" />
      <FooterAction
        :routePath="'/inventory-check'"
        @customAction="confirmAlertModal()"
        :saveText="form.status == 3 ? 'เสร็จสิ้น' : 'ยืนยัน'"
        backText="ย้อนกลับ"
        @submit="submit"
        :hideSubmit="form.status == 0 || form.status == 1 || form.status == 4"
      >
        <template #left>
          <b-button
            v-if="form.status < 3"
            variant="outline-primary-color"
            class="btn-width ml-3"
            @click="confirmAlertModal"
          >
            ยกเลิก
          </b-button>
        </template></FooterAction
      >
      <ModalAlertConfirm
        ref="modalAlertConfirm"
        :msg="confirmMessage.msg"
        @confirm="(val, test) => cancelForm(val)"
    /></template>
    <template v-else>
      <Report
        :type="page"
        @close="page = 1"
        ref="reportInventoryCheck"
        :invoice="form.inventory_check_no"
      />
    </template>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea.vue";
import FooterAction from "@/components/FooterAction";
import InputSelect from "@/components/inputs/InputSelect";
import { mapGetters } from "vuex";

import { required } from "vuelidate/lib/validators";
import ModalScanProduct from "./components/ModalScanProduct";
import Report from "./components/Report";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm.vue";
export default {
  components: {
    InputText,
    InputTextArea,
    FooterAction,
    ModalAlertConfirm,
    InputSelect,
    ModalScanProduct,
    Pagination,
    Report,
  },
  validations() {
    return {
      note: {
        text: {
          required,
        },
      },
    };
  },

  data() {
    return {
      tabIndex: 0,
      isBusy: false,

      filter: {
        search: "",
        inventory_check_id: Number(this.$route.params.id),
        page: 1,
        take: 10,
        is_scanned: 1, // 0 ยังไม่สแกน 1 สแกนแล้ว
      },
      fields: [
        { label: "รูป", key: "image_url" },
        { label: "Barcode", key: "barcode" },
        { label: "Serial", key: "serial_name" },

        { label: "ราคา", key: "product_price" },
        {
          label: "เลขเอกสาร",
          key: "document_no",
        },
        {
          label: "จำนวน",
          key: "inventory_stock",
        },
        {
          label: "จำนวนที่นับ",
          key: "count_stock",
          tdclass: "text-danger",
        },
      ],
      productList: [],

      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      notScanItems: [],
      scanItems: [],
      rows: 0,
      id: this.$route.params.id,
      form: {
        id: 0,
        inventory_check_no: "",
        branch_id: "",
        stock_type_ids: null,
        stock_type_id: 0,
        created_by: "",
        created_time: "",
        updated_by: "",
        updated_time: "",
        set_stock_by: "",
        set_stock_time: "",
        start_check_by: null,
        start_check_time: null,
        submitted_by: null,
        submitted_time: null,
        approved_by: null,
        approved_time: null,
        status: 0,
      },
      countDown: false,
      confirmMessage: {
        msg: "ยกเลิกตรวจสอบสินค้าคงคลัง",
      },
      productCount: [
        {
          id: 0,
          name_en: "Not Scanned",
          name_th: "ยังไม่สแกน",
          count: 0,
        },
        {
          id: 0,
          name_en: "Scanned",
          name_th: "สแกนแล้ว",
          count: 0,
        },
      ],
      page: 1,
    };
  },
  watch: {
    tabIndex(value) {
      if (value == 1)
        this.fields.push({
          label: "Action",
          key: "action",
        });
      else this.fields.splice(this.fields.length - 1, 1);
      this.filter = {
        search: "",
        inventory_check_id: Number(this.$route.params.id),
        page: 1,
        take: 10,
        is_scanned: value, // 0 ยังไม่สแกน 1 สแกนแล้ว
      };
      this.getProductList(value);
    },
  },
  async created() {
    // this.now = this.$moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    // await this.getRepairCauseList();
    if (this.id > 0) {
      await this.getDetail();
      this.getCountProduct();
    }
    // if (this.id == 0) {
    //   this.form.created_user_guid = this.$cookies.get("saleId");
    // }
    // await this.getFieldSetting();
  },

  computed: {
    stockName() {
      return this.form.stock_type.map((el) => el.name).join(", ");
    },
    ...mapGetters({
      mainLoading: "getMainLoading",
      userGuid: "getUserGuid",
      isFullPos: "getIsFullPos",
      branchId: "getBranchId",
      plantId: "getPlantId",
      salesNo: "getSalesNo",
      branchName: "getBranchName",
      branchType: "getBranchType",
    }),
  },

  methods: {
    async getProductList(type) {
      this.isBusy = true;
      const res = await this.axios.post(
        `${this.$baseUrl}/inventorycheck/get-check-product`,
        {
          ...this.filter,
          is_scanned: type,
        }
      );
      let key = { 0: "notScanItems", 1: "scanItems" };

      this[key[type]] = res.detail.data;
      this.rows = res.detail.total;
      this.isBusy = false;
    },
    async getDetail() {
      const res = await this.axios(
        `${this.$baseUrl}/inventorycheck/get/${this.id}`
      );
      this.form = res.detail;
      this.getProductList(this.tabIndex);
    },
    pagination(value) {
      this.filter.page = value;
      this.getProductList(this.tabIndex);
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.getProductList(this.tabIndex);
    },
    onSearch() {
      this.getProductList(this.tabIndex);
    },
    onClickIcon() {},

    async handleCountDown() {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.axios.post(
        `${this.$baseUrl}/inventorycheck/set-stock`,
        {
          inventory_check_id: Number(this.id),
          sales_no: this.$cookies.get("saleId"),
          // "created_time": "2025-05-07 12:05:25" server time instaed
        }
      );
      await this.$store.dispatch("setMainLoading", false);

      if (res.result) {
        this.getDetail();
        this.getCountProduct();
        this.successAlert();
      } else {
        this.errorAlert(res.message);
      }
    },
    async confirmAlertModal() {
      this.confirmMessage = {
        msg: "ยกเลิกตรวจสอบสินค้าคงคลัง",
      };
      this.$refs.modalAlertConfirm.show();
    },
    isShowScanProduct() {
      this.$refs.ModalScanProduct.show();
    },
    async cancelForm() {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.axios.post(
        `${this.$baseUrl}/inventorycheck/cancel-stock`,
        {
          inventory_check_id: this.$route.params.id,
        }
      );
      await this.$store.dispatch("setMainLoading", false);
      if (res.result == 1)
        await this.successAlert(), this.$router.push("/inventory-check");
      else this.errorAlert(res.message);
    },
    async removeProduct(id) {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.axios.post(
        `${this.$baseUrl}/inventorycheck/delete-product`,
        {
          inventory_check_id: this.$route.params.id,
          inventory_check_product_id: id,
        }
      );
      await this.$store.dispatch("setMainLoading", false);
      if (res.result == 1) await this.successAlert(), this.refreshProduct();
      else this.errorAlert(res.message);
    },
    async submit() {
      var res = null;
      await this.$store.dispatch("setMainLoading", true);
      if (this.form.status == 3) {
        this.$bus.$emit("pinOpened", 1);
        this.$bus.$on("getAsyncData", async (resolve) => {
          // console.log(resolve);
          res = await this.axios.post(
            `${this.$baseUrl}/inventorycheck/approve-stock`,
            {
              inventory_check_id: this.$route.params.id,
              sales_no: resolve,
            }
          );
          await this.$store.dispatch("setMainLoading", false);
          if (res.result)
            await this.successAlert(), this.$router.push("/inventory-check");
          else this.errorAlert(res.message);
        });
      } else {
        res = await this.axios.post(
          `${this.$baseUrl}/inventorycheck/submit-stock`,
          {
            inventory_check_id: this.$route.params.id,
            sales_no: this.$cookies.get("saleId"),
          }
        );
      }

      await this.$store.dispatch("setMainLoading", false);
      if (res.result)
        await this.successAlert(), this.$router.push("/inventory-check");
      else this.errorAlert(res.message);
    },
    async getCountProduct() {
      const res = await this.axios(
        `${this.$baseUrl}/inventorycheck/get-count-check-product/by-inventory-check-id/${this.$route.params.id}`
      );
      this.productCount = res.detail;
    },
    refreshProduct() {
      if (this.form.status == 1) this.getDetail();
      this.getCountProduct();
      this.getProductList(this.tabIndex);
    },
    async updateCountstock(event, items) {
      if (event.keyCode === 13) {
        let payload = {
          sales_no: this.$cookies.get("saleId"),
          inventory_check_product_id: items.id,
          count: items.count_stock, // จำนวนที่ต้องอัพเดท
        };
        const res = await this.axios.post(
          `${this.$baseUrl}/inventorycheck/update-product-scan`,
          payload
        );
      }
    },
    async exportItems() {
      this.$refs.reportInventoryCheck.exportFile(this.page);
      // const res = await this.axios.post(
      //   `${this.$baseUrl}/inventorycheck/report/get-check-product-group`,
      //   {
      //     inventory_check_id: this.$route.params.id,
      //   }
      // );
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  color: #333 !important;
  font-size: 16x !important;
  font-weight: bold !important;
}

.title-w {
  width: 160px;
}

.display-user-value {
  border: #c9c8c8 1px solid;
  width: 230px;
  min-height: 30px;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  padding: 2px 10px;
  font-size: 14px;
  color: #404040;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    color: #404040;
    font-size: 10px;
  }
}

.fa-search {
  width: 32px;
  height: 32px;
  margin-left: 10px;
  border-radius: 50%;
  border: 1px none #fff;
  background-color: var(--primary-color) !important;
  padding: 5px 7px;
}
.custom-btn {
  height: 32px;
}

.calendar-icon {
  position: absolute;
  top: 20%;
  right: 3%;
}
.calendar-icon-top {
  top: 35% !important;
}
.datetime-container {
  position: relative;
  width: 230px;
}

.custom-date-picker ::v-deep input {
  height: 35px !important;
}

.space-bottom {
  padding-bottom: 80px;
}

.img-size {
  width: 50px;
  height: 50px;
}

.title-detail {
  color: #333 !important;
  font-size: 16x !important;
  font-weight: bold !important;
}

.input-w {
  width: 300px !important;
}

.activity-footer {
  display: flex;
  justify-content: flex-end;
  margin: 24px 0;
  gap: 8px;
}

.action-button {
  color: black;
  background-color: rgb(225 225 225);

  padding: 0.5rem;
  display: inline-flex;
  font-size: 16px;
  cursor: pointer;
}

.f-18px {
  font-size: 18px;
  font-weight: bold;
}
</style>
